import React from 'react';

export function Logo(props) {

    const style = { ...props.style, width: (props.width ? props.width : undefined), height: (props.height ? props.height : props.width ? props.width : undefined) };

    return <div className={props.className} style={style}>
        <img className="inside" src="https://artofjoycdn.blob.core.windows.net/images/ArtofJoyLogo.jpg" alt="logo"/>
        </div>
}